export const PAID_PENDING_TEXT =
  "Payment received. We're finishing your order — if it doesn't show up soon, contact support.";

const REFUNDED_TEXT = 'This reward ran out or changed before your payment went through, so we refunded your card.';

// The card already went through when this runs, so no outcome may offer the pay button again.
export const cardPaymentOutcome = (answer) => {
  if (answer?.redemption_id) return { kind: 'redeemed' };
  if (answer?.refunded) return { kind: 'refunded', message: answer.detail || REFUNDED_TEXT };
  return { kind: 'pending', message: (answer?.paid && answer.detail) || PAID_PENDING_TEXT };
};
